import { Link } from "react-router-dom";
import { OmniLogo } from "./OmniLogo";

export function Logo({ size = "md", linkTo = "/", showWordmark = true, brand = "search", wordmarkLabel }) {
  const sizes = {
    sm: { glyph: 28, text: "text-lg" },
    md: { glyph: 36, text: "text-xl" },
    lg: { glyph: 56, text: "text-3xl" },
    xl: { glyph: 88, text: "text-5xl sm:text-6xl" },
  };
  const s = sizes[size] || sizes.md;
  // Wordmark
  const default_labels = {
    search: ["Omni", "Search", "var(--omni-accent)"],
    mail: ["Omni", "Mail", "#E11D48"],
    tube: ["Omni", "Tube", "#DC2626"],
    ai: ["Omni", "AI", "#7C3AED"],
    drive: ["Omni", "Drive", "#F59E0B"],
    map: ["Omni", "Map", "#10B981"],
  };
  const [a, b, color] = wordmarkLabel || default_labels[brand] || default_labels.search;
  const inner = (
    <div className="flex items-center gap-3" data-testid="omni-logo">
      <OmniLogo brand={brand} size={s.glyph} />
      {showWordmark && (
        <span className={`font-black tracking-tight ${s.text}`}>
          {a}<span style={{ color }}>{b}</span>
        </span>
      )}
    </div>
  );
  if (!linkTo) return inner;
  return <Link to={linkTo} className="inline-flex">{inner}</Link>;
}
